import ModalBody from '@/components/Modal/common/ModalBody';
import { Button, Modal } from '@mui/material';

interface IProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  textContent: string;
  buttonText?: string;
}

const TextViewModal = ({ open, handleClose, title, textContent, buttonText = 'Close' }: IProps) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <ModalBody>
        <p className='text-center pt-2 mb-6 text-xl font-semibold'>{title}</p>
        <p className='whitespace-pre-wrap break-words border border-[#0000001a] rounded-md p-2.5'>{textContent}</p>
        <div className='flex justify-end mt-4'>
          <Button
            variant='contained'
            onClick={handleClose}
            sx={{
              height: '48px',
              width: '130px',
            }}
          >
            <span>{buttonText}</span>
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TextViewModal;
